import React from "react";

const WrapDisplayScope = (props) => {
    const { data, children, ...rest } = props;
    if (!data?.displayScope) return <div {...rest}>{children}</div>;

    const displayCss =
        data.displayScope === "Small"
            ? "flex md:hidden w-full"
            : data.displayScope === "Large"
            ? "hidden md:flex w-full"
            : "";

    return (
        <div className={displayCss} {...rest}>
            {children}
        </div>
    );
};

export default WrapDisplayScope;
